import decode from 'jwt-decode';
import { omit } from 'lodash';
import calculateRemainingTime from 'src/util/calculateRemainingTime';

const authReducer = (state, action) => {
  switch (action.type) {
    case 'refreshSession': {
      const expirationTime = new Date(action.payload * 1000);
      localStorage.setItem('expirationTime', expirationTime);
      return { ...state, remainingTime: calculateRemainingTime(expirationTime) };
    }
    case 'updateAccount': {
      return { ...state, account: { ...state.account, ...action.payload } };
    }
    case 'login': {
      const decoded = decode(action.payload.token);
      const expirationTime = new Date(action.payload.exp * 1000);
      localStorage.setItem('expirationTime', expirationTime);
      return {
        ...state,
        token: action.payload.token,
        account: omit(decoded, 'iat', 'exp'),
        remainingTime: calculateRemainingTime(expirationTime),
      };
    }
    case 'loginBackdoor': {
      const decoded = decode(action.payload.token);
      const expirationTime = new Date(action.payload.exp * 1000);
      localStorage.setItem('expirationTime', expirationTime);
      localStorage.setItem('backdoor', true);

      return {
        ...state,
        token: action.payload.token,
        account: omit(decoded, 'iat', 'exp'),
        remainingTime: calculateRemainingTime(expirationTime),
        backdoor: true,
      };
    }
    case 'logout':
    case 'clear-token':
      localStorage.removeItem('expirationTime');
      localStorage.removeItem('backdoor');
      return {
        ...state,
        token: '',
        account: null,
        remainingTime: null,
        logoutNotified: true,
        backdoor: false,
      };

    case 'clear-logout-notified':
      return { ...state, logoutNotified: false };
  }
};

export default authReducer;
